export enum GoalSettingRoute {
  GoalSelection = 'goal-selection',
  ProductSelection = 'product-selection',
}
